export default function Loading() {
    return <div className="row">
        <div className="col-12">
            <div className="row justify-content-center">
                <div className="spinner-border text-secondary" role="status">
                    <span className="visually-hidden"></span>
                </div>
            </div>
        </div>
    </div>
};